module.exports = __webpack_public_path__ + "static/img/ea.5c0daa3e.svg";